module.exports = {"id":"188567","name":"Pierre-Emerick Aubameyang","rating":"87","photo":"./data/images/photos/4/188567.png","club":{"name":"Arsenal","logo":"./data/images/clubs/Arsenal.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Pierre-EmerickAubameyang0.json
// module id = 3459
// module chunks = 0